document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'designGallery', () => ({

		ticking: false,

		init() {
			this.mql = window.matchMedia( '(max-width: 767px)' );

			this.onScroll = () => {
				if ( this.ticking ) {
					return;
				}
				this.ticking = true;
				window.requestAnimationFrame( () => {
					if ( this.mql.matches ) {
						this.resetFigures();
					} else {
						this.compute();
					}
					this.ticking = false;
				});
			};

			window.addEventListener( 'scroll', this.onScroll, { passive: true });
			window.addEventListener( 'resize', this.onScroll, { passive: true });
			this.onScroll();

			this.$cleanup = () => {
				window.removeEventListener( 'scroll', this.onScroll );
				window.removeEventListener( 'resize', this.onScroll );
			};
		},

		resetFigures() {
			const figures = this.$el.querySelectorAll( '.design-gallery__figure' );
			figures.forEach( ( fig ) => {
				fig.style.removeProperty( 'opacity' );
				fig.style.removeProperty( 'transform' );
			});
		},

		compute() {
			const stage = this.$el.querySelector( '.design-gallery__stage' );
			const card  = this.$el.querySelector( '.design-gallery__card' );
			if ( ! stage || ! card ) {
				return;
			}

			const figures = this.$el.querySelectorAll( '.design-gallery__figure' );
			if ( ! figures.length ) {
				return;
			}

			const stageRect = stage.getBoundingClientRect();
			const cardH     = card.offsetHeight;

			// The pin offset must match `top` on .design-gallery__pin (2rem).
			const pinOffset = 2 * parseFloat( getComputedStyle( document.documentElement ).fontSize );

			// Animation runs only while the card is pinned: progress 0 the
			// moment the card top reaches the pin offset, progress 1 once the
			// stage has scrolled the remaining distance under it.
			const travel    = stageRect.height - cardH;
			const traveled  = pinOffset - stageRect.top;
			const progress  = 0 < travel ? Math.min( 1, Math.max( 0, traveled / travel ) ) : 0;

			// Subtle stagger: each image's animation starts a fraction later
			// than the previous so they overlap heavily but not perfectly in
			// sync. Scroll-driven, so the offset is in progress units.
			const stagger = 0.12;

			// The last image trails by this much; stretch the raw scroll
			// progress so its fade-out completes exactly as the card unpins
			// (rather than being cut off when stickiness releases).
			const lastOffset = ( figures.length - 1 ) * stagger;
			const span       = progress * ( 1 + lastOffset );

			figures.forEach( ( fig, i ) => {
				const p = Math.min( 1, Math.max( 0, span - ( i * stagger ) ) );

				// Scale: 0.3 → 1.45 — the image zooms toward the viewer, passing
				// 1.0 near the midpoint (peak opacity) and continuing to grow as
				// it fades out.
				const scale = 0.3 + ( p * 1.15 );

				// Opacity: fade in over first 35%, hold, fade out over last 35%.
				let opacity;
				if ( 0.35 > p ) {
					opacity = p / 0.35;
				} else if ( 0.65 > p ) {
					opacity = 1;
				} else {
					opacity = ( 1 - p ) / 0.35;
				}

				fig.style.opacity   = opacity.toFixed( 3 );
				fig.style.transform = `scale( ${ scale.toFixed( 3 ) } )`;
			});
		},
	}) );
});
